import { onMounted, onUnmounted } from 'vue'

/** One viewport owner for Safari browser chrome and the software keyboard. */
export function useAppViewport() {
  let viewport: VisualViewport | null = null
  let frame = 0
  const update = () => {
    cancelAnimationFrame(frame)
    frame = requestAnimationFrame(() => {
      // Do not resize the application while the user pinch-zooms.
      if (viewport && viewport.scale !== 1) return
      const root = document.documentElement.style
      root.setProperty('--app-viewport-height', `${viewport?.height ?? window.innerHeight}px`)
      root.setProperty('--app-viewport-top', `${viewport?.offsetTop ?? 0}px`)
      // iOS keeps the layout viewport under the keyboard, so bottom sheets must lift themselves.
      const keyboard = viewport ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0
      root.setProperty('--app-keyboard-inset', `${keyboard}px`)
    })
  }
  onMounted(() => {
    viewport = window.visualViewport
    viewport?.addEventListener('resize', update)
    viewport?.addEventListener('scroll', update)
    window.addEventListener('resize', update)
    update()
  })
  onUnmounted(() => {
    cancelAnimationFrame(frame)
    viewport?.removeEventListener('resize', update)
    viewport?.removeEventListener('scroll', update)
    window.removeEventListener('resize', update)
    document.documentElement.style.removeProperty('--app-viewport-height')
    document.documentElement.style.removeProperty('--app-viewport-top')
    document.documentElement.style.removeProperty('--app-keyboard-inset')
  })
}
